import { isUndefined, isNil, isString, has } from "lodash/fp";
import apis from "../core/apis";

function resourcesFactory(
  $q,
  $rootScope,
  Authentication,
  cfpLoadingBar,
  CityHandler
) {
  "ngInject";

  return {
    request(config) {
      if ($rootScope.isLoggedin) {
        const expirationDate = new Date(
          Authentication.getValue("expirationDate")
        );
        const now = new Date();

        if (now > expirationDate) {
          if (!$rootScope.isRefreshingToken) {
            $rootScope.$emit("event:auth-loginRequired");
          }

          // If token refreshing reject other request
          if (apis.refreshToken !== config.url) {
            return $q.reject({
              data: {
                message:
                  "Your login token is expired, please wait while refreshing it",
              },
            });
          }
        }
        if (apis.refreshToken === config.url) {
          // Ignore auth interceptor check if refresh token api  failed to reject the request
          // to consume refresh token api rejection callback to logout user
          config.ignoreAuthModule = true;
        }
      }

      const checkCityRequired = (params) => {
        if (isUndefined(params.isCityRequired)) params.isCityRequired = true;

        return params.isCityRequired;
      };

      const token = Authentication.getValue("token");
      const city =
        !isNil(config.params) && !isNil(config.params.city)
          ? config.params.city
          : CityHandler.get();
      let cityId = null;
      if (!isNil(city)) {
        if (isString(city)) cityId = city;
        else if (has("id")(city)) cityId = city.id;
        else if (has("_id")(city)) cityId = city._id;
      }
      const isCityRequired = config.params
        ? checkCityRequired(config.params)
        : true;
      const isEndPointRegex = /swvl/g;
      const isEndPoint = isEndPointRegex.test(config.url);
      const isGETReq = config.method === "GET";

      cfpLoadingBar.start();

      if (config.params) {
        delete config.params.isCityRequired;
        if (Object.prototype.hasOwnProperty.call(config.params, "city")) {
          delete config.params.city;
        }
      }
      if (token) config.headers.Authorization = `Bearer ${token}`;
      if (isCityRequired && cityId && isEndPoint && isGETReq) {
        config.params = Object.assign({ city: cityId }, config.params);
      }

      return config;
    },

    response(response) {
      cfpLoadingBar.complete();

      return response;
    },

    responseError(rejection) {
      cfpLoadingBar.complete();

      return $q.reject(rejection);
    },
  };
}

export default resourcesFactory;



// WEBPACK FOOTER //
// ./src/resources/factory.js